/** Normalizes email for auth API calls (trim + lowercase). */
export function normalizeAuthEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Normalizes full name for auth API calls (trim only). */
export function normalizeFullName(name: string): string {
  return name.trim();
}
